import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger,} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {ProductRetrocessionModel} from '../../../api/entity/productRetrocession.model';
import {ProductRetrocessionConverter} from '../../../api/entity/converter/productRetrocession.converter';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';

@Injectable()
export class ProductRetrocessionDataService extends AbstractDataServiceV2<ProductRetrocessionModel, ProductRetrocessionConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator, logger: Logger, config: DefaultDataServiceConfig,
                converter: ProductRetrocessionConverter) {
        super('ProductRetrocession', http, httpUrlGenerator, logger, config, converter);
    }
}
